// removed by extract-text-webpack-plugin
module.exports = {"taxonToggle":"MainPage-m__taxonToggle___31wO_","taxonToggle_content":"MainPage-m__taxonToggle_content___35FNg","taxonToggleContent":"MainPage-m__taxonToggle_content___35FNg"};


//////////////////
// WEBPACK FOOTER
// ./containers/mainPage/MainPage.m.sass
// module id = avSM
// module chunks = 0